const pathConfig = {
  register: {
    path: '/register',
    confirmEmail: {
      path: 'email-confirmation',
      withToken: {
        path: 'email-confirmation/:token',
        to: '/register/email-confirmation/:token',
      },
    },
    apiRegister: {
      path: 'api',
    },
  },
  login: {
    path: '/login',

    resetPassword: {
      path: 'reset-password',

      withToken: {
        path: 'reset-password/:token',
      },
    },
    forgetPassEmail: {
      path: 'forget-password-email-success',
    },
  },
  home: {
    path: '/',
  },
  privacy_statement: {
    path: '/privacy-policies',
  },
  notifications: {
    path: '/notifications',
  },
  wallet: {
    path: '/wallet',

    info: {
      path: '/wallet/:id',

      withdraw: {
        path: '/wallet/:id/withdraw',
      },
    },
    withdrawConfirm: {
      path: '/wallet/withdrawal-confirm',
    },
    legacyWallets: {
      path: '/wallet/legacy-wallets',
    },
  },
  tokenConvert: {
    path: '/token-convert',
  },
  tokenProductions: {
    path: '/tokenProductions/:id',
  },
  interconnectWallets: {
    path: '/interconnect',
  },
  packagePurchase: {
    path: '/packages/avatar-purchase',
    to: '/packages/avatar-purchase',
    packages: {
      path: '/packages/avatar-purchase',
      to: '/packages/avatar-purchase',
    },
    purchasedPackages: {
      path: 'purchased-packages',
      to: '/packages/avatar-purchase/purchased-packages',
    },
    purchasedPackagesSponsorBonus: {
      path: 'purchased-packages-sponsor-bonus',
      to: '/packages/avatar-purchase/purchased-packages-sponsor-bonus',
    },
  },
  annualPercentageYield: {
    path: '/packages/annual-percentage-yield',
    to: '/packages/annual-percentage-yield',
    annualPurchasedPackages: {
      path: '/packages/annual-percentage-yield',
      to: '/packages/annual-percentage-yield',
    },
    annualPurchased: {
      path: 'annual-purchased-packages',
      to: '/packages/annual-percentage-yield/annual-purchased-packages',
    },
    annualSponsorBonus: {
      path: 'annual-sponsor-bonus',
      to: '/packages/annual-percentage-yield/annual-sponsor-bonus',
    },
  },
  globalMarketingPlan: {
    path: '/packages/global-marketing-plan',
    to: '/packages/global-marketing-plan',
    globalMarketingPurchasePackages: {
      path: '/packages/global-marketing-plan',
      to: '/packages/global-marketing-plan',
    },
    globalMarketingPurchased: {
      path: 'global-purchased-packages',
      to: '/packages/global-marketing-plan/global-purchased-packages',
    },
    globalMarketingSponsorBonus: {
      path: 'global-sponsor-bonus',
      to: '/packages/global-marketing-plan/global-sponsor-bonus',
    },
    starPackagesProfit: {
      path: 'starPackagesProfit',
      to: '/packages/global-marketing-plan/starPackagesProfit',
    },
  },
  vimePurchase: {
    path: '/packages/vime-packages',
    to: '/packages/vime-packages',
    vimePurchasePackages: {
      path: '/packages/vime-packages',
      to: '/packages/vime-packages',
    },
    vimePurchased: {
      path: 'vime-purchased-packages',
      to: '/packages/vime-packages/vime-purchased-packages',
    },
    vimeSponsorBonus: {
      path: 'vime-sponsor-bonus',
      to: '/packages/vime-packages/vime-sponsor-bonus',
    },
  },
  vimeMbasePurchase: {
    path: '/wallet/vime-with-mbase',
    to: '/wallet/vime-with-mbase',
    vimeMbasePurchasePackages: {
      path: '/wallet/vime-with-mbase',
      to: '/wallet/vime-with-mbase',
    },
    vimeMbasePurchased: {
      path: 'vime-mbase-purchased',
      to: '/wallet/vime-with-mbase/vime-mbase-purchased',
    },
    vimeMbaseSponsorBonus: {
      path: 'vime-mbase-sponsor-bonus',
      to: '/wallet/vime-with-mbase/vime-mbase-sponsor-bonus',
    },
  },
  characterPurchase: {
    path: '/wallet/character-purchase',
    to: '/wallet/character-purchase',
    characterPurchasePackages: {
      path: '/wallet/character-purchase',
      to: '/wallet/character-purchase',
    },
    characterPurchased: {
      path: 'character-purchased',
      to: '/wallet/character-purchase/character-purchased',
    },
    characterSponsorBonus: {
      path: 'character-sponsor-bonus',
      to: '/wallet/character-purchase/character-sponsor-bonus',
    },
  },
  globalCompensationAPY: {
    path: '/packages/apy-packages',
    to: '/packages/apy-packages',
    apyPackages: {
      path: '/packages/apy-packages',
      to: '/packages/apy-packages',
    },
    apyPackagesPurchased: {
      path: 'purchased-packages',
      to: '/packages/apy-packages/purchased-packages',
    },
    apyPackagesSponsorBonus: {
      path: 'sponsor-bonus',
      to: '/packages/apy-packages/sponsor-bonus',
    },
  },
  metaverseLand: {
    path: '/packages/metaverse-land',
    to: '/packages/metaverse-land',
    land: {
      path: '/packages/metaverse-land',
      to: '/packages/metaverse-land',
    },
    puchasedMetaverseLand: {
      path: 'purchased-land',
      to: '/packages/metaverse-land/purchased-land',
    },
  },
  legacyProducts: {
    path: '/packages/legacy-products',
    to: '/packages/legacy-products',
    avatar: {
      path: 'purchased-avatar',
      to: '/packages/legacy-products/purchased-avatar',
    },
    globalPurchased: {
      path: 'purchased-gmp',
      to: '/packages/legacy-products/purchased-gmp',
    },
    quarterlyProfit: {
      path: 'quarterly-profit',
      to: '/packages/legacy-products/quarterly-profit',
    },
    apy: {
      path: 'purchased-apy',
      to: '/packages/legacy-products/purchased-apy',
    },
    apyStar: {
      path: 'purchased-apy-star',
      to: '/packages/legacy-products/purchased-apy-star',
    },
    sponsorBonuses: {
      path: 'sponsor-bonuses',
      to: '/packages/legacy-products/sponsor-bonuses',
    },
    apyPayout: {
      path: 'apy-payout',
      to: '/packages/legacy-products/apy-payout',
    },
    apyStarPayout: {
      path: 'apy-star-payout',
      to: '/packages/legacy-products/apy-star-payout',
    },
  },
  gcp: {
    path: '/gcp',
    to: '/gcp',
    compensationDownline: {
      path: 'compensation-downline',
      to: '/gcp/compensation-downline',
    },
    compensationHistory: {
      path: 'compensation-history',
      to: '/gcp/compensation-history',
    },
    compensationCreditHistory: {
      path: 'compensation-credit-history',
      to: '/gcp/compensation-credit-history',
    },
    myEarning: {
      path: 'my-earning',
      to: '/gcp/my-earning',
    },
    unilevelTree: {
      path: 'unilevel-tree',
      to: '/gcp/unilevel-tree',
      treeView: {
        path: 'tree-view',
        to: '/gcp/unilevel-tree/tree-view',
      },
      // tableView: {
      //   path: '/gcp/unilevel-tree/table-view',

      // },
    },
    gcpCommissions: {
      path: 'commissions',
      to: '/gcp/commissions',
    },
  },
  profile: {
    path: '/profile',
    to: '/profile',
    personalInfo: {
      path: '/profile',
      to: '/profile',
    },
    security: {
      path: 'security',
      to: '/profile/security',
      settings: {
        path: '/profile/security',
        to: '/profile/security',
      },
      changePassword: {
        path: 'security/change-password',
        to: '/profile/security/change-password',
      },
      mfa: {
        path: 'security/2fa',
        to: '/profile/security/2fa',
      },
    },
    minebaseTeam: {
      path: 'minebase-team',
      to: '/profile/minebase-team',
    },
    bonus: {
      path: '/profile/bonus',
      to: '/profile/bonus',
    },
    support: {
      path: '/profile/support',
      to: '/profile/support',
    },
    documents: {
      path: 'documents',
      to: '/profile/documents',
      singleDoc: {
        path: 'documents/:id',
        to: '/profile/documents/:id',
      },
    },
    emailManagement: {
      path: 'email-management',
      to: '/profile/email-management',
    },
    downlineUsers: {
      path: 'downline-users',
      to: '/profile/downline-users',
    },
    userStatus: {
      path: 'user-status',
      to: '/profile/user-status',
      userStatus: {
        path: '/profile/user-status',
        to: '/profile/user-status',
      },
      miningWallet: {
        path: 'status-address',
        to: '/profile/user-status/status-address',
      },
    },
    directSales: {
      path: 'direct-sales',
      to: '/profile/direct-sales',
    },
  },
  documents: {
    path: '/documents',

    singleDoc: {
      path: '/documents/:id',
    },
  },
  support: {
    path: '/contact',
  },
  changeEmailWithToken: {
    path: '/change-email/:token',
  },
  notFound: {
    path: '/not-found',
  },
  unsubscribeWithToken: {
    path: '/unsubscribe',
  },
}

export default pathConfig
